import React from "react";
import Paper from "@material-ui/core/Paper";
import Chip from "@material-ui/core/Chip";
import ChipScrollBar from "../../components/ChipScrollBar";

export default function SectionChipBar({ chips, onChipClick }) {
    return (
        <div className="kakousiji-topchip-anchor">
            <Paper
                className="kakousiji-topchip-paper kakousiji-topchip-paper-content"
                component="div"
                elevation={0}
            >
                <ChipScrollBar>
                <ul className="kakousiji-topchip-list">
                    {chips.map((chip) => (
                        <li className="kakousiji-topchip-item" key={"topchip_" + chip.id}>
                            <Chip
                                label={chip.label}
                                title={chip.label}
                                size="small"
                                onClick={() => onChipClick(chip.id)}
                            />
                        </li>
                    ))}
                </ul>
                </ChipScrollBar>
            </Paper>
        </div>
    );
}
